import { Component } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';

@Component
export default class InputPassword extends InputBase<string> {

  private password: string =  '';
  private showPass: boolean = false;

  protected mounted() {
    this.inputType = 'password';
  }
}
